export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/financing-icon.1f8034db.svg","height":15,"width":16,"blurWidth":0,"blurHeight":0};